// extracted by mini-css-extract-plugin
export default {"title":"Body_title__yy1mn"};